import createReactComponent from '../createReactComponent';
export default createReactComponent('square-plus', 'IconSquarePlus', [
  ['path', { d: 'M9 12h6', key: 'svg-0' }],
  ['path', { d: 'M12 9v6', key: 'svg-1' }],
  [
    'path',
    {
      d: 'M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z',
      key: 'svg-2',
    },
  ],
]);
